module.exports = __webpack_public_path__ + "static/media/bulk1.b381f592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/bulk1.jpg
// module id = 1627
// module chunks = 0